// src/utils/loadCSS.js
export default function loadCSS(href, id) {
  if (id && document.getElementById(id)) return;
  if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) return;

  const link = document.createElement("link");
  if (id) link.id = id;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = href;
  link.onload = () => { /* Optionally: console.log(`${href} loaded`); */ };
  link.onerror = () => { console.error(`Failed to load CSS: ${href}`); };
  document.head.appendChild(link);
}
